import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'assessment',
	landing: {
		route: null,
	},
	funnel: {
		id: 'crm_assessment',
		// @ts-expect-error - Legacy: slug не совпадает с appArea, будет исправлено позже
		slug: 'crm_assessment',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-email',
	},
	upsell: {
		routeNames: ['upsell-static-assessment-result', 'upsell-f'],
	},
}

export default appAreaConfig
